<template>
  <section class="page-courses-sub-cat pt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="text-right mb-4">
            <h1 class="font-20">لیست زیرمجوعه ها</h1>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row no-gutters justify-content-center">
            <list-course
              :item="item"
              :image="appUrl.media + '/' + item.Img"
              :cols="cols"
              v-for="(item,index) in listCourse"
              :key="item.id"
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center text-center w-100">
        <page-number :lengthList="lengthList" @callBack="getBySub"/>
      </div>
    </div>
  </section>
</template>

<script>
import listCourse from "cp/list-course.vue";
export default {
  name: "page-courses-sub-cat",
  components: {
    "list-course": listCourse
  },
  data() {
    return {
      isLoading: true,
      lengthList: 12,
      page: 1,
      cols: {
        row: false,
        col: "col-lg-3 col-md-4 col-sm-6 col-6 col-xs px-2"
      }
    };
  },
  computed: {
    listCourse() {
      return this.$store.state.courses.someCatsListCourse;
    },
    subId() {
      return this.$route.params.subId;
    }
  },
  watch: {
    subId(val) {
      if (val) {
        this.getBySub(this.page, this.subId);
      }
    }
  },
  mounted() {
    this.getBySub(this.page, this.subId);
  },
  methods: {
    async getBySub(page, id) {
      this.isLoading = true;
      await this.$store.dispatch("courses/getByCat", {
        id: id || this.subId,
        page
      });
      this.isLoading = false;
    }
  }
};
</script>
<style lang="less" scoped>
.col-xs {
  @media screen and (max-width: 380px) {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 1;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/courses/_cat/_sub/_subId.vue